import styled from 'styled-components/macro';
import { COLORS } from 'styleguide';

const Duration = styled.div`
  display: inline-flex;
  align-items: center;
  margin-left: 20px;
  height: 26px;
  padding: 5px 11px;
  background-color: ${COLORS.line};
  border-radius: 3px;
  font-size: 16px;
  color: #fff;
  opacity: 0.6;

  span {
    margin-left: 10px;
  }
`;

export default Duration;
